export default ({ dropdown }) => ({
  tooltip: {
    position: 'absolute',
    zIndex: 1,
    padding: [10, 0, 0],
    '&.direction-up': {
      bottom: '100%',
      padding: [0, 0, 10]
    },
    '& p': {
      margin: 0,
      padding: [4, 10],
      lineHeight: '16px',
      fontSize: 14
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 5,
      top: 1,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: [0, 8, 9, 8],
      borderColor: `transparent transparent ${dropdown.border} transparent`
    },
    '&.direction-up::before': {
      top: 'auto',
      bottom: 1,
      borderWidth: [9, 8, 0, 8],
      borderColor: `${dropdown.border} transparent transparent transparent`
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 5,
      top: 2,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: [0, 8, 9, 8],
      borderColor: `transparent transparent ${dropdown.background} transparent`
    },
    '&.direction-up::after': {
      bottom: 2,
      top: 'auto',
      borderWidth: [9, 8, 0, 8],
      borderColor: `${dropdown.background} transparent transparent transparent`
    }
  },
  contentWrapper: {
    overflow: 'auto',
    border: `1px solid ${dropdown.border}`,
    background: dropdown.background,
    padding: [2, 0],
    height: '100%'
  }
});
